import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@constructionautomation/backend";
import type { FunctionReturnType } from "convex/server";

export type ViewerGuide = NonNullable<FunctionReturnType<typeof api.onboarding.getViewerGuide>>;
export type GuideNextAction = NonNullable<ViewerGuide["guide"]>["nextAction"];
export type GuideStepKey = NonNullable<ViewerGuide["guide"]>["steps"][number]["key"];

/**
 * Role capabilities, commercial access, and first-use progress for the signed-in user. `null`
 * while loading or without an organization; callers should then render their default UI.
 */
export function useViewerGuide(): ViewerGuide | null {
  const { data } = useQuery(convexQuery(api.onboarding.getViewerGuide, {}));
  return data ?? null;
}
